Application = require('resources/assets/coffee/Core/Application').Application

class exports.AngularApplication extends Application

    constructor: (options = {}) ->
        @angular_default_route = '/dashboard'

        ###
         * @angular_routes
         *     Registry of Router classes to boot up with the angular app
         *
        ###
        @angular_routes = []

        ###
         * @angular_modules
         *     Registry of angular modules to register when the angular app boots
         *
         * Below are common angular modules that will likely
         * be used by any angular app we're building
        ###
        @angular_modules = [
            'angular-plupload'
            'ui.router'
            'ui.router.upgrade'
            'ui.bootstrap'
            'ngAnimate'
            'ngSanitize'
            'datatables'
            'ui.select'
            'angularSpinner'
            'ngHandsontable'
            'smart-table'
            'ui.date'
            'ui.sortable'
            'ngResource'
            # 'ui.validate'
            'chart.js'
            'ngFileUpload'
            'LocalStorageModule'
            'ngCookies'
            'angular-loading-bar'
            'ngMessages'
            # 'ui.utils'
        ]

        if Raven?
            @angular_modules.push 'ngRaven'

        ###
         * @angular_directives
         *     Registry of angular directives to initialize when the angular app boots
         *
         * Below are common angular directives / filters that will
         * likely be used by any angular app we're building
        ###
        @angular_directives = [
            'core::Directives/mfSlideToggle'
            'core::Directives/mfWhenScroll'
            'core::Directives/modalWindowDraggable'
            'core::Directives/mfForceDecimal'
            'core::Directives/mfDatepicker'
            'core::Directives/mfRangeDatepicker'
            'core::Directives/mfClickOutside'
            'core::Directives/stopEvent'
            'core::Directives/mfResizable'
            'core::Directives/mfMessageWriter'
            'core::Directives/noNg'
            'core::Directives/mfFixedHeader'
            'core::Directives/mfCenterDialog'
            'core::Directives/mfValidate'
            'core::Directives/mfValidateSave'
            'core::Directives/mfValidateModel'
            'core::Directives/mfValidateRepeat'
            'core::Directives/mfErrorsContainer'
            'core::Directives/mfError'
            'core::Directives/mfTopBuffer'
            'core::Directives/mfSlider'
            'core::Directives/contenteditable'
            'core::Directives/mfSlider'
            'core::Directives/mfMentionContainer'
            'core::Directives/mfMentionSelection'
            'core::Directives/mfMentionToggle'
            'core::Directives/mfMentionInput'
            'core::Directives/mfDataViewHeight'
            'core::Directives/mfClickover'
            'core::Directives/mfClickInputFile'
            'core::Directives/mfFocusMe'
            'core::Directives/mfClickAndDisable'
            'core::Directives/mfPluploader'
            'core::Directives/mfCustomDataPdfDownloadFixedTableHeader'
            'core::Directives/mfCustomDataMapDownloadFixedTableHeader'
            'core::Directives/mfSyncScrollTop'
            'core::Directives/mfSyncScrollLeft'
            'core::Directives/mfUiSelectOnBlur'
            'core::Directives/mfUiSelectButton'
            'core::Directives/mfKeyboardTableNav'
            'core::Directives/mfFormatWholeNumber'
            'core::Directives/mfPostRepeat'
            'core::Directives/mfCarousel'
            'core::Directives/mfKeypress'
            'core::Directives/mfAutoSelectOnlyOption'
            'core::Directives/mfClearInvalidSelection'
            'core::Directives/mfNoOptions'
            'core::Directives/mfUibBtnRadio'
            'core::Directives/mfUibBtnRadioYesNo'
            'core::Directives/mfFpcMissing'
            'core::Directives/mfNSolverMissing'
            'core::Directives/mfPopoverValidate'
            'core::Directives/mfNumber'
            'core::Directives/mfGuardMax'
            'core::Directives/mfGuardMin'

            # Custom Validation
            'core::Directives/Validation/mfIsDatePickerFormat'
            'core::Directives/Validation/mfIsDateInPast'
            'core::Directives/Validation/mfIsGreaterThanZero'
            'core::Directives/Validation/mfIsLessThan'
            'core::Directives/Validation/mfIsNotNegative'
            'core::Directives/Validation/mfIsInt'
            'core::Directives/Validation/mfIsEmail'
            'core::Directives/Validation/mfMaxLength'
            'core::Directives/Validation/mfValidateDependingOn'
            'core::Directives/Validation/mfHasOptions'

            # Custom Filters
            'core::Filters/mfPhoneFormat'
            'core::Filters/natSort'
            'core::Filters/mfUcWords'
        ]

        @angular_services = [
            'core::Services/Map'
            'core::Services/MapLayers/Base'
            'core::Services/MapLayers/Soil'
            'core::Services/MapLayers/ManagementZone'
            'core::Services/MapLayers/YieldMap'
            'core::Services/MapLayers/CombinedLayers'
            'core::Services/MapLayers/PopulationMap'
            'core::Services/MapLayers/FieldBoundary'
            'core::Services/MapLayers/Manager'
            'core::Services/Session'
            'core::Services/Loading'
            'core::Services/Routing'
            'core::Services/Steps'
        ]

        $(window).on 'app:booting', () =>
            @initAngular()

        # $(window).on 'DOMContentLoaded', () =>
        #     angular.bootstrap(document, ['MyFarmsApp'], { strictDi: true })


        super(options)


    initGlobals: () ->
        super()
        # Additional stuff for angular
        @load 'bower::select2/select2'
        @load('bower::angular-route/angular-route')
        @load('bower::angular-animate/angular-animate')
        @load('bower::angular-sanitize/angular-sanitize')
        @load('bower::angular-resource/angular-resource')
        # @load('bower::angular-ui-router/release/angular-ui-router')
        @load('bower::angular-plupload/dist/angular-plupload.min')
        @load('bower::ng-grid-bower/ng-grid')
        @load('bower::angular-ui-bootstrap-bower/ui-bootstrap-tpls')
        @load('bower::angular-datatables/dist/angular-datatables')
        # Why the EFF are we including BOTH?
        # @load('bower::ui-select/dist/select')
        @load('bower::angular-ui-date/src/date')
        @load('bower::angular-ui-sortable/sortable')
        # @load('bower::angular-ui-validate/dist/validate')
        @load('yarn::angular-chart.js/dist/angular-chart')
        @load('bower::angular-ui-select/dist/select')

        @load('yarn::angular-spinner/angular-spinner')
        @load('bower::myfarms-nghandsontable/dist/ngHandsontable')
        @load('bower::angular-smart-table/dist/smart-table')
        @load('bower::ng-file-upload/ng-file-upload')
        @load('bower::angular-local-storage/dist/angular-local-storage')
        @load('bower::angular-cookies/angular-cookies')
        @load('bower::angular-loading-bar/build/loading-bar')
        @load('bower::angular-messages/angular-messages')
        # @load('bower::angular-ui-utils/ui-utils')

    ###
     * addAngularRoutes: (routes) ->
     *     - routes (array): array of Router option objects to boot up
     *
     * Allows you to register new Routers into the @angular_routes list.
     *
     * Note: this should be used before initAngular is called, as that is
     * when the angularApp is booted.
    ###
    addAngularRoutes: (routes) =>
        $.merge(@angular_routes, routes)

    ###
     * addAngularDirectives: (directives) ->
     *     - directives (array): array of directives to register
     *
     * Allows you to add additional angular directives to be
     * registered to the app.
     *
     * Note: this should be used before initAngular is called, as that is
     * when the angularApp is booted.
    ###
    addAngularDirectives: (directives) =>
        $.merge(@angular_directives, directives)


    addAngularServices: (services) =>
        $.merge(@angular_services, services)

    ###
     * addAngularModules: (modules) ->
     *     - modules (array): array of modules to register
     *
     * Allows you to add additional angular modules to
     * be registered to the app. This will typically be used
     * if you are wanting to use an external angular library,
     * such as 'ui.router' or 'ngAnimate'
     *
     * Note: this should be used before initAngular is called, as that is
     * when the angularApp is booted.
    ###
    addAngularModules: (modules) =>
        $.merge(@angular_modules, modules)


    _registerRouters: (modules) =>
        for options in @angular_routes
            rclass = @loadClass(options.path)
            if typeof rclass isnt 'function'
                throw new Error "File at \"#{options.path}\" does not contain a valid class definition."

            options.router = new rclass()
            if not options.router.__proto__.hasOwnProperty('register')
                throw new Error "Class at \"#{options.path}\" is not a valid Router. " +
                    '(It must implement the register() method.)'

            if options.router.module_name?
                modules.push options.router.module_name

            options.router.register()


    _registerDirectives: () =>
        for name in @angular_directives
            d = @loadClass name
            if d.register?
                d.register(@angularApp)

    _registerServices: () =>
        for name in @angular_services
            d = @load name
            if d.register?
                d.register(@angularApp)

    ###
     * initAngular: () ->
     *
     * Initializes the angular application. This takes care
     * of registering modules, directives, and any routers that
     * have been added. This also manages some standard configuration.
     *
     * If you need to reference the angular application instance at any
     * time, App.angularApp contains it.
    ###
    initAngular: () =>
        modules = @angular_modules.slice()

        @_registerRouters(modules)

        app = angular.module 'MyFarmsApp', modules
        @angularApp = app

        @angularApp.config(['$urlServiceProvider', ($urlService) => $urlService.deferIntercept()])

        @_registerDirectives()
        @_registerServices()

        # This is here so that the session service's constructor runs immediately.
        # Otherwise, the HTTP headers won't be set for the initial page load.
        app.run ['$http', 'Core.Services.Session', '$timeout', '$state', ($http, session, $timeout, $state) =>

            # If we *think* we are logged in, then check it for real
            if session.get 'Authorization'
                # See what user id we are and register ourselves with the websocket connection
                $http.get "#{Config.get('api_url')}/me"
                .then (response) =>
                    Raven?.setUserContext response.data
                    Socket.whenopen () ->
                        Socket.socket?.send response.data.id
                .catch (error) =>
                    $state.go 'login'
        ]


        # Uncomment if you want to temporarily log transition debug code (helpful for "transition superseded" errors)
        # app.run ['$trace', ($trace) =>
        #     $trace.enable('TRANSITION')
        # ]

        app.run ['$state', ($state) =>
            Socket.register 'logout', () =>
                $state.go 'logout'
        ]

        # support defining states that are tied to a modal dialog
        # adapted from http://stackoverflow.com/a/24726331/814160
        app.config ['$stateProvider', ($stateProvider) ->
            $stateProvider.modalState = (stateName, options) ->
                modalInstance = null
                $stateProvider.state stateName,
                    url: options.url
                    params: options.params
                    template: '<div></div>'
                    onEnter: ['$uibModal', '$state', '$transition$', ($modal, $state, $transition$) ->
                        parent = stateName.substring(0, stateName.lastIndexOf('.'))

                        options.resolve ?= {}
                        options.resolve['$transition$'] = -> $transition$

                        modalInstance = $modal.open(options)
                        modalInstance.result.finally () ->
                            modalInstance = null
                            if _.startsWith $state.$current.name, stateName
                                # don't use '^' because it doesn't go to the
                                # correct state if the dialog has child states
                                if options.reloadOnClose
                                    $state.go parent, null, reload: parent
                                else
                                    $state.go parent
                            return
                        return # otherwise CS returns crap that breaks the Angular state
                    ]
                    onExit: () ->
                        modalInstance?.close()
                        options.onClose?()
                        return # just for good measure

            return # also needed because CS is retar- I mean, "silly"
        ]

        # Set up a couple of default controllers we'll want to reference
        # TODO: Set up a general Router for common controllers, which is loaded by default
        DialogController = @loadClass 'core::Angular/DialogController'
        DeleteDialogController = @loadClass 'core::Angular/DeleteDialogController'
        ConfirmDialogController = @loadClass 'core::Angular/ConfirmDialogController'
        MainController = @loadClass 'core::Angular/MainController'
        DashboardController = @loadClass 'core::Angular/DashboardController'
        DashboardDropdownController = @loadClass 'core::Angular/DashboardDropdownController'
        AdminHeaderController = @loadClass 'core::Angular/AdminHeaderController'
        ApiDataForwardingController = @loadClass 'core::Angular/ApiDataForwardingController'

        app.controller 'MainController', [
            '$scope'
            '$transitions'
            '$rootScope'
            '$state'
            'Core.Services.Session'
            '$timeout'
            '$interval'
            '$http'
            '$ngModal'
            MainController
        ]

        app.controller 'DialogController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            DialogController
        ]
        app.controller 'DeleteDialogController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            DeleteDialogController
        ]
        app.controller 'ConfirmDialogController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            ConfirmDialogController
        ]
        app.controller 'DashboardController', [
            '$scope'
            '$state'
            '$http'
            'Core.Services.Session'
            'Core.Services.Routing'
            '$window'
            DashboardController
        ]
        app.controller 'DashboardDropdownController', [
            '$scope'
            DashboardDropdownController
        ]
        app.controller 'AdminHeaderController', [
            '$scope'
            '$state'
            '$http'
            '$window'
            'Core.Services.Session'
            AdminHeaderController
        ]
        app.controller 'ApiDataForwardingController', [
            '$scope'
            '$location'
            '$stateParams'
            '$http'
            'Core.Services.Session'
            ApiDataForwardingController
        ]

        BinDetailsController = @loadClass 'core::Angular/BinDetailsController'
        app.controller 'BinDetailsController',
            [
                '$scope'
                '$transitions'
                '$uibModalInstance'
                '$uibModal'
                'OnFarmStorage.Services.OnFarmStorageService'
                '$q'
                'bin'
                'noSave'
                BinDetailsController
            ]

        # Set up the application. This is the primary configuration
        # for general app behavior
        app.config [
            '$stateProvider'
            '$urlRouterProvider'
            '$interpolateProvider'
            'pluploadOptionProvider'
            '$locationProvider'
            'cfpLoadingBarProvider'
            (
                $stateProvider,
                $urlRouterProvider,
                $interpolateProvider,
                pluploadOptionProvider,
                $locationProvider,
                cfpLoadingBarProvider
            ) =>
                cfpLoadingBarProvider.parentSelector = '#loading-bar-container'
                cfpLoadingBarProvider.includeSpinner = false

                # Set default plupload options
                pluploadOptionProvider.setOptions
                    silverlight_xap_url: 'bower_components/plupload/js/Moxie.xap'
                    multi_selection: true
                    max_file_count: 200
                    flash_swf_url: 'bower_components/plupload/js/Moxie.swf'
                    max_file_size: '1000mb'
                    chunk_size: '2mb'
                    runtimes: 'html5,flash,silverlight'
                    filters: []

                # We're swapping our
                # interpolate symbols, because blade already uses {{ and }}.
                $interpolateProvider.startSymbol '<%'
                $interpolateProvider.endSymbol '%>'

                # Set the default route
                if @angular_default_route?
                    $urlRouterProvider.otherwise @angular_default_route

                # Set up the controller routing
                for options in @angular_routes
                    options.router.registerRoutes $stateProvider, $urlRouterProvider

                $locationProvider.html5Mode(true).hashPrefix('!')
        ]

        ###
         * IF we receive a "denied" JSONresponse from ANY angular HTTP
         * request, we want to show the Permission Denied template.
        ###
        app.factory 'accessInterceptor',
        ['$q', ($q) ->
            response: (response) ->
                if response.data?.status?.type is 'denied'
                    # This is bad, but it can go away once everything is angularized
                    $('.sidebar_content').html(response.data.view)
                return response or $q.when(response)
        ]

        ###
         * IF we receive a "logout" JSONresponse from ANY angular HTTP
         * request, we want to automatically go to the login page.
        ###
        app.factory 'logoutInterceptor',
        ['$rootScope', '$q', '$window', 'localStorageService', ($rootScope, $q, $window, $localStorage) ->
            response: (response) ->
                if response.data?.status?.type is 'logout'
                    $state.go 'login'
                    #return $q.reject(response)
                return response or $q.when(response)

            responseError: (rejection) ->
                data = rejection.data
                if typeof(data) isnt 'object'
                    data = JSON.parse(data)

                if rejection.status is 401 and data?.error is 'Unauthenticated.'
                    $localStorage.set 'previous_location', $window.location
                    $rootScope.$broadcast 'unauthorized'
                    return $q.resolve rejection

                return $q.reject rejection
        ]

        ###
         * Hook up our logoutInterceptor, and also make sure
         * that laravel can detect angular http as ajax
        ###
        app.config ['$httpProvider', ($httpProvider) ->
            $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
            $httpProvider.defaults.headers.common['X-Units'] = if App.is_metric then 'metric' else 'standard'
            $httpProvider.interceptors.push 'logoutInterceptor'
            $httpProvider.interceptors.push 'accessInterceptor'
        ]

        ###
        # What we are doing here is hacking into the $http service by using a
        # decorator. The purpose is to add a function to allow the frontend
        # to decide when it is time to safelink by using the method like:
        # $http.safelink().method(). When safelinking, save the header
        # "Authorization" (masqueraded user) and temporarily replace
        # it with the SafeLink header, but only for one http call.
        # Afterwards, replace the header with the saved version.
        # See what dumb comments you make when you try to get
        # the lengths to be in a pattern? Silly totwell...
        #
        # Update: we don't need this anymore cause things
        # are stupid and dumb, but I don't want to delete
        # in case we need it again sometime in the future
        ###
        # app.decorator '$http', ['$delegate', ($delegate) =>
        #     $delegate.safelink = () ->
        #         @doSafelink = true
        #         return $delegate

        #     for func in ['get', 'post', 'delete', 'put']
        #         originalFunction = $delegate[func]
        #         $delegate.get = () ->
        #             originalUser = @defaults.headers.common.Authorization
        #             safeLinkUser = @defaults.headers.common.SafeLink

        #             if @doSafelink
        #                 @defaults.headers.common.Authorization = safeLinkUser

        #             result = originalFunction.apply $delegate, arguments

        #             @defaults.headers.common.Authorization = originalUser
        #             @doSafelink = false

        #             return result

        #         return $delegate
        # ]

        ###
         * Set default ui-select theme
        ###
        app.config ['uiSelectConfig', (select) ->
            select.theme = 'select2'
        ]

        ###
         * Set defaults for uib-modals
        ###
        app.config ['$uibModalProvider', ($uibModalProvider) ->
            $uibModalProvider.options.appendTo = angular.element('#bs2-container')
        ]

        app.run ['$transitions', ($transitions) =>
            $transitions.onStart {}, ($transition) =>
                $templateCache = $transition.injector().get('$templateCache')

                # If the grower site is navigated to manually or by any means other than through /grower (like the ingredion urls),
                # then we wouldn't ever transition from the /grower state and we wouldn't ever clear the template from the cache
                $templateCache.remove 'backend/grower/home/index'

                for view, viewData of $transition.from().views

                    # These are templates that we want to remove from the template cache so that they are refetched
                    # every time. We do not want to remove every template, because that would make the site very slow.
                    # The reason we have to remove these is because there is some logic in the blade file that changes
                    # the output depending on some condition that can change (e.g., masquerading changes the name in the
                    # dropdown). Eventually, we can remove this hack when everything is angularized and we don't use
                    # conditionals or loops or variables in any of the blade templates.
                    if [
                        'backend/grower/data/ng-sidebar'
                        'backend/grower/fieldprint/steps'
                        'backend/grower/nsolver/steps'
                        'backend/portal/home/index'
                    ].indexOf(viewData.templateUrl) >= 0
                        $templateCache.remove viewData.templateUrl

                # Destroy the old-school handler, unless it really needs to stay
                # open while we're at this state and we're not reloading it.
                # This can go away once literally everything is Angularized.
                if App.current_page?
                    destroy_handler = true
                    if App.current_page.angular_states? and
                            $transition.from().name isnt $transition.to().name
                        for state_name in App.current_page.angular_states
                            if _.startsWith($transition.to().name, state_name)
                                destroy_handler = false
                                break
                    if destroy_handler
                        App.current_page.destroy()
                        App.current_page = null
        ]
